The details of the `HiringOrganization` requesting the verification.
